import { http, HttpResponse } from 'msw'

import { allPermissions } from 'app/mocks/data/users/profiles/permissions'

import { api } from 'app/utils/constants'

import { PermissionsRequest } from 'app/types/users/profile/permission'

export const getAllPermissions = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.PERMISSIONS}`,
    () => {
        return HttpResponse.json<PermissionsRequest>({
            results: allPermissions,
        })
    },
)
